import { render, staticRenderFns } from "./APSAEducateSearch.vue?vue&type=template&id=1cfb3974&scoped=true"
import script from "./APSAEducateSearch.vue?vue&type=script&lang=js"
export * from "./APSAEducateSearch.vue?vue&type=script&lang=js"
import style0 from "./APSAEducateSearch.vue?vue&type=style&index=0&id=1cfb3974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb3974",
  null
  
)

export default component.exports